import { Injectable } from '@angular/core';
import confetti from "canvas-confetti";

@Injectable({
  providedIn: 'root'
})
export class ConfettiService {

  private timeouts: any[] = [];
  constructor() { }

  fire(particleRatio: number, opts: any) {
    confetti(Object.assign({}, {}, opts, {
      particleCount: Math.floor(200 * particleRatio)
    }));
  }

  fireworksFullScreen(duration: number = 10) {
    this.fireworks(1, {min: 0.1, max: 0.9}, {min: 0, max: 0.8}, duration * 1000);
  }

  fireworksPlayerOneOppositeLayout(duration: number = 10) {
    this.fireworks(1, {min: 0.1, max: 0.9}, {min: 0.7, max: 1.0}, duration * 1000);
  }

  fireworksPlayerTwoOppositeLayout(duration: number = 10) {
    this.fireworks(-1, {min: 0.1, max: 0.9}, {min: 0.0, max: 0.3}, duration * 1000);
  }

  fireworksPlayerOneSideBySideLayout(duration: number = 10) {
    this.fireworks(1, {min: 0.6, max: 0.9}, {min: 0.0, max: 0.8}, duration * 1000);
  }

  fireworksPlayerTwoSideBySideLayout(duration: number = 10) {
    this.fireworks(1, {min: 0.1, max: 0.4}, {min: 0.0, max: 0.8}, duration * 1000);
  }

  fireworks(gravity: number, xRange: {min: number, max: number}, yRange: {min: number, max: number}, duration: number = 10 * 1000) {
    const velocity = gravity > 0 ? 25 : -25;

    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    function randomInRange(min: number, max: number) {
      return Math.random() * (max - min) + min;
    }

    const interval: any = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        this.stop();
      }

      this.fire(0.1,
        {
          spread: 120,
          startVelocity: velocity,
          decay: 0.92,
          scalar: 1.2,
          gravity: gravity,
          origin: { x: randomInRange(xRange.min, xRange.max), y: randomInRange(yRange.min, yRange.max) }
        });
    }, 500);
    this.timeouts.push(interval);
  }

  stop() {
    this.timeouts.forEach(timeout => {
      if(timeout) {
        clearTimeout(timeout);
      }
    });
    this.timeouts = [];
  }
}
